<mat-dialog-actions class="flex gap-5 px-[32px] py-6">
  <div class="buttons flex w-full gap-2"
       [ngClass]="{'justify-end': buttons.length === 1}">
    <app-button *ngFor="let button of buttons"
                [style]="button.style"
                [color]="button.color"
                [icon]="button.icon"
                (click)="button.action()"
                [disabled]="button.disabled"
                [attr.aria-label]="'Footer button ' + button.text">
      {{ button.text | translate }}
    </app-button>
    <ng-content></ng-content>
  </div>
</mat-dialog-actions>
